import { ref, remove } from 'firebase/database';
import { SessionWithId } from '../../Models/session';
import { database } from '../firebase';
import { getSession } from './GetSession';

export const DeleteSession: (session: SessionWithId) => Promise<void> = async (
    session,
) => {
    let currentSession = null;

    try {
        currentSession = await getSession(session);

        if (currentSession?.session.people) {
            throw Error('Na tuto lekci je někdo přihlášen. Nelze zrušit.');
        }

        await remove(ref(database, `sessions/${session.id}`));
    } catch (error) {
        if (currentSession?.session.people) {
            throw error;
        } else {
            throw new Error(
                'Lekci nelze zrušit. Zkuste to později, případně kontaktujte správce',
            );
        }
    }

    return;
};
